<template>
  <Select
    v-model="model"
    filterable
    remote
    clearable
    :label="label"
    @on-change="onChange"
    :remote-method="remoteMethod"
    :loading="loading"
    transfer
  >
    <Option
      v-for="teacher in teacherList"
      :value="teacher.id"
      :key="teacher.id"
    >
      {{ teacher.id }} - {{ teacher.firstName }} {{ teacher.lastName }} -
      {{ teacher.email }}
    </Option>
  </Select>
</template>
<script>
export default {
  name: 'TeacherSelect',
  props: {
    value: {
      type: [Number, String]
    },
    label: {
      type: String
    },
    status: {
      type: Number
    },
    isAudition: {
      type: Number
    },
    category: {
      type: [Array]
    },
    statusList: {
      type: [Array],
      default: []
    },
    isCanBound: { // 老师是否可绑定
      type: Number
    },
    uid: { // 学生ID
      type: Number
    }
  },
  data () {
    return {
      teacherList: [],
      loading: false,
      model: this.value
    }
  },
  methods: {
    remoteMethod (query) {
      query = query === null ? '' : query.trim()
      if (query === null || query === '') {
        this.teacherList = []
        return
      }
      let self = this
      self.loading = true
      let params = { status: self.status, infoKeyword: query, isCanBound: self.isCanBound, isAudition: self.isAudition, uid: self.uid }
      let index = 0
      self.category.forEach(element => {
        params['categories[' + (index++) + ']'] = element
      })
      self.statusList.forEach(element => {
        params['statusList[' + (index++) + ']'] = element
      })
      self.$http.get('/tch/listByCondition', { params: params }).then(function (res) {
        self.teacherList = res.data
        self.loading = false
      })
    },
    onChange (value) {
      this.$emit('input', value)

      let tch = this.teacherList.filter(item => item.id === value)[0]
      this.$emit('change-select', tch)

      if (tch) {
        let name = tch.firstName + ' ' + tch.lastName
        this.$emit('on-change', value, name)
      } else {
        this.$emit('on-change', value, '')
      }
    },
  },
  mounted: function () {
  },
  watch: {
    value (val) {
      this.model = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// TeacherSelect.vue?4a10d948